module.exports = __webpack_public_path__ + "static/media/striped_bar_finalinspect.bcf7df6e.svg";